export default __webpack_public_path__ + "static/media/023-gamer.8528d3df.svg";